import { Component } from 'react';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import {LogoutModal} from './logout.js';
const moment = require('moment');

class MoMList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data          :[],
      isLoading     :true
    };
  }

  async getMoMs() {
    try {
      const response = await fetch('/api/moms');
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getMoMs();
  }

  render() {
    if(!this.state.isLoading){
      const moms = this.state.data;
      const mom_list = moms.map((mom)=>
          <tr key={mom.id} id={mom.id}>
              <td>{moment(mom.created_date).format('l')}</td>
              <td>{mom.title}</td>
              <td>{mom.posted_by}</td>
              <td>{mom.file_url &&
                <a href={mom.file_url} target="_blank" className="fw-bold" id={mom.id}>View</a>}
              </td>
          </tr>
      );
      return(
          <>
          <div className="row">
              <div className="col-lg-12 col-md-12 col-xs-12">
                  <div className="card shadow mb-4">
                      <div className="card-header py-3">
                          <h4 className="m-0 font-weight-bold text-white">Meeting Minutes</h4>
                      </div>
                      <div className="card-body">
                          <div className="table-responsive mom-form">
                              <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                  <thead>
                                      <tr>
                                          <th>Created On</th>
                                          <th>Title</th>
                                          <th>Posted By</th>
                                          <th></th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {mom_list}
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          </>
      );
    }
  }
}

function MOM() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <MoMList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { MOM };
